import { FlexBox } from "@braze/beacon-core";
import styled from "styled-components";

export const ViewContainer = styled(FlexBox)`
 height: 100%;
 align-items: center;
 display: flex;
 flex-direction: column;
 overflow: scroll;
 z-index: 1;
 padding-bottom: 3rem;
`;